import { LanguagesEnum } from 'common/enums/languages'

type BridgeErrorContent = {
  title: string
  description: string
  primaryButton: string
  secondaryButton: string
}

export const bridgeErrorMessages: Record<LanguagesEnum, { bridgeFailure: BridgeErrorContent }> = {
  [LanguagesEnum.PT_BR]: {
    bridgeFailure: {
      title: 'Não foi possível carregar a página',
      description: 'Ocorreu um erro ao conectar com o aplicativo. Tente novamente.',
      primaryButton: 'Tentar novamente',
      secondaryButton: 'Voltar',
    },
  },
  [LanguagesEnum.EN_US]: {
    bridgeFailure: {
      title: 'Unable to load the page',
      description: 'There was an error connecting to the app. Please try again.',
      primaryButton: 'Try again',
      secondaryButton: 'Go back',
    },
  },
  [LanguagesEnum.ES_ES]: {
    bridgeFailure: {
      title: 'No se pudo cargar la página',
      description: 'Hubo un error al conectar con la aplicación. Inténtalo de nuevo.',
      primaryButton: 'Intentar de nuevo',
      secondaryButton: 'Volver',
    },
  },
}
